import React, { useState, useContext } from "react";
import { SearchContext } from "../../context/SearchContext";
import { AuthContext } from "../../context/AuthContext";
import { LanguageContext } from "../../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Link } from "react-router-dom";

export default function Header() {
  const [showSearch, setShowSearch] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showLangDropdown, setShowLangDropdown] = useState(false);
  const { search, setSearch } = useContext(SearchContext);
  const { user, isAuthenticated, logout } = useContext(AuthContext);
  const { language, setLanguage } = useContext(LanguageContext);
  const navigate = useNavigate();

  const handleSearchClick = () => {      // arama cubuguna tiklaninca input calisin
    setShowSearch((prev) => !prev);
  };

  const handleInputChange = (e) => {
    setSearch(e.target.value);
  };


  const handleProfileClick = () => setShowDropdown((prev) => !prev);

  // Çıkış işlemi
  const handleLogout = () => {
    logout();
    setShowDropdown(false);
    navigate("/");
  };

  // Dil menüsünü aç/kapat
  const handleLangClick = () => setShowLangDropdown((prev) => !prev);
  // Dil seçimi
  const handleLangSelect = (lang) => {
    setLanguage(lang);
    setShowLangDropdown(false);
  };

  return (
    <Navbar expand="lg" className="bg-body-tertiary" data-bs-theme="light">
      <Container>
        <Navbar.Brand href="/">Lale Kuruyemişci</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="ms-2" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-start mt-3 mt-lg-0">
            <Nav.Link href="/">Ana Sayfa</Nav.Link>
            <Nav.Link href="/about">Hakkımızda</Nav.Link>
            <Nav.Link href="/category">Ürünler</Nav.Link>
          </Nav>
        </Navbar.Collapse>

        <div className="d-flex align-items-center gap-2 ms-auto">
          {showSearch && (
            <input
              type="text"
              className="form-control d-none d-lg-block"
              placeholder="Ara..."
              value={search}
              onChange={handleInputChange}
              autoFocus
              style={{ width: 200, transition: "width 0.3s" }}
            />
          )}
          <button
            className="btn btn-outline-dark border-0 rounded-0 d-none d-lg-block"
            onClick={handleSearchClick}
          >
            <i className="bi bi-search"></i>
          </button>
          <div className="position-relative">
            <button
              className="btn btn-outline-dark border-0 rounded-0"
              onClick={handleLangClick}
              type="button"
            >
              <i className="bi bi-globe2"></i>
            </button>
            {showLangDropdown && (
              <div
                className="position-absolute bg-white border shadow rounded py-2 px-3 mt-1"
                style={{ right: 0, minWidth: 120, zIndex: 1000 }}
              >
                <button
                  className={`dropdown-item small px-0 ${language === "tr" ? "fw-bold text-primary" : ""}`}
                  style={{ background: "none", border: "none" }}
                  onClick={() => handleLangSelect("tr")}
                >
                  Türkçe
                </button>
                <button
                  className={`dropdown-item small px-0 ${language === "en" ? "fw-bold text-primary" : ""}`}
                  style={{ background: "none", border: "none" }}
                  onClick={() => handleLangSelect("en")}
                >
                  English
                </button>
              </div>
            )}
          </div>
          {isAuthenticated ? (
            <div className="position-relative">
              <span
                className="btn btn-dark rounded-0 px-3 d-flex align-items-center gap-1"
                style={{ cursor: "pointer" }}
                onClick={handleProfileClick}
              >
                <i className="bi bi-person me-1"></i>
                <span>{user?.name}</span>
              </span>
              {showDropdown && (
                <div
                  className="position-absolute bg-white border shadow rounded py-2 px-3 mt-1"
                  style={{ right: 0, minWidth: 120, zIndex: 1000 }}
                >
                  <button
                    className="dropdown-item text-danger small px-0"
                    style={{ background: "none", border: "none" }}
                    onClick={handleLogout}
                  >
                    Çıkış Yap
                  </button>
                </div>
              )}
            </div>
          ) : (
            <Link to="/login" className="btn btn-dark rounded-0 px-3">
              <i className="bi bi-person me-1"></i>
            </Link>
          )}
        </div>
      </Container>
    </Navbar>
  );
}
